import { gql } from "@apollo/client";

export const REJECT_INVOICES = gql`
  mutation rejectInvoices($invoices: [RejectInvoiceItemInput!]!) {
    invoice {
      rejectInvoices(invoices: $invoices) {
        errorMessage
        invoiceId
        success
      }
    }
  }
`;
